import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Sales/customers'

export default {
  namespaced: true,
  state: {
    loading: false,
    customers: {
      data: [],
      grandTotals: {
        daily: 0,
        monthly: 0,
        chartData: {
          series: [],
          labels: [],
        },
      },
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    customers(state) {
      return state.customers
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_CUSTOMERS(state, data) {
      state.customers = data
    },
    /* RESET MUTATIONS */
    RESET_CUSTOMERS(state) {
      state.customers = {
        data: [],
        grandTotals: {
          daily: 0,
          monthly: 0,
          chartData: {
            series: [],
            labels: [],
          },
        },
      }
    },
  },
  actions: {
    getCustomers({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_CUSTOMERS')
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_CUSTOMERS', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
  },
}
